/**
 * rest 请求配置
 */
import ajax from '../common/ajax'

// 预约租车接口配置项
const optionsV1 = {
  baseUrl: '/api/v1/rent_car',
  cache: false
}

const optionsV2 = {
  baseUrl: '/api/v1',
  cache: false
}

export default {
  // 预约租车配置相关
  rent: {
    // 车辆信息
    getCarInfo: ajax.query('/list_rentable_models', optionsV1),
    // 可租车时间
    getRentInfo (id) {
      // return ajax.query(`/list_rentable_datetime/${id}`, optionsV1)
      return ajax.query(`/book_vehicle/${id}`, optionsV1)
    },
    // 租车信息提交
    postSuccess: ajax.create('/rent_car_orders', optionsV1)
  },
  auth: {
    // 获取验证码
    createVeiCode: ajax.create('/auth/verification_code', optionsV2)
  },
  coupon: {
    // 提交客户信息领取优惠券
    createChannelCoupon: ajax.create('/coupon/channel_coupon', optionsV2),
    // 通过token获取优惠券信息
    fetchIssueChannelCouponInfo: ajax.query('/coupon/issue_channels', optionsV2),
    // 获取发行渠道部分信息
    fetchIssueChannelProfile: ajax.query('/coupon/issue_channel_profile', optionsV2),
    // 创建发放渠道优惠券链接token
    creatCouponIssueChannelToken: ajax.query('/coupon/issue_channel_token', optionsV2),
    // 生成二维码
    createQrCode: ajax.create('/coupon/qr_code', { ...optionsV2, responseType: 'blob' }),
    // 生成二维码预检查
    createQrCodePrefight: ajax.create('/coupon/qr_code', optionsV2),
    // 获取验证码
    fetchSendVeliCode: ajax.create('/coupon/verification_code', optionsV2),
    // 获取优惠券页面通过token获取优惠券信息1
    fetchReceChannelCouponInfo: ajax.query('/coupon/channel_coupon', optionsV2)
  }
}



// WEBPACK FOOTER //
// ./src/rest/config.js